import {useCallback, useState} from 'react';

export interface ParserState {
    loading: boolean;
    error: Error | null;
    wrap: <T>(fn: () => Promise<T>) => Promise<T>;
}

export function useParserState(): ParserState {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const wrap = useCallback(async <T>(fn: () => Promise<T>): Promise<T> => {
        setLoading(true);
        setError(null);
        try {
            return await fn();
        } catch (err) {
            const e = err instanceof Error ? err : new Error('Parsing failed');
            setError(e);
            throw e;
        } finally {
            setLoading(false);
        }
    }, []);

    return {loading, error, wrap};
}
